const NoMatch = () => (
    <h1 className="text-info">Sorry, the page you requested could not be found! 🦄</h1>
)

export default NoMatch